(ns dre.panels.refine-search.views)


(defn view
  []
  "Refine search")
